import React, { useState, useEffect } from "react";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import "./Frota.css";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import { motion } from "framer-motion";
import { getFrota } from "../../../services/ModuloChecklist/GerenciamentoFrota";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import { useNavigate } from "react-router-dom";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";

function Frota() {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = () => {
		setOpenToastErro(false);
	};

	const [textoErro, setTextoErro] = useState("");

	const [listaCaminhao, setListaCaminhao] = useState([]);

	const [listaCarreta, setListaCarreta] = useState([]);

	const [loading, setLoading] = useState(true);

	const buscarFrotas = async () => {
		if (!profile?.token) return;
		setLoading(true);
		await getFrota(profile?.token)
			.then((result) => {
				setListaCaminhao(result.data.caminhaos);
				setListaCarreta(result.data.carreta);
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const navigate = useNavigate();

	const setTelaCheck = () => {
		navigate("/cadastro-check");
	};

	useEffect(() => {
		buscarFrotas();
	}, []);

	useEffect(() => {
		if (!profile) return;
		setSemAutorizacao(!hasRegra("Gerenciamento de Frota"));
	}, [profile]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 />
			{!loading && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<div className="indicadores-frota">
						<p className="indicador-principal-frota">Caminhões Frota</p>
						<p className="indicador-principal-frota">Carretas Frota</p>
					</div>
					<div className="principal-frotas">
						<TabelaV2
							setTelaCheck={setTelaCheck}
							classeSelecionado="idCaminhao"
							nomeClasse1="outer-wrapper-rota"
							nomeClasse2="table-wrapper-v2"
							colunas={tabelaEmpresa.Caminhao}
							dados={listaCaminhao}
						/>
						<TabelaV2
							setTelaCheck={setTelaCheck}
							classeSelecionado="idCarreta"
							nomeClasse1="outer-wrapper-rota"
							nomeClasse2="table-wrapper-v2"
							colunas={tabelaEmpresa.Carreta}
							dados={listaCarreta}
						/>
					</div>
					<div>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
					</div>
				</motion.div>
			)}
			{loading && <LoadingComponent />}
		</motion.div>
	);
}

export default Frota;
